import Vue from "vue";
import Router from "vue-router";

import kfhdRoutes from "./kfhd";
import kfhdRoutes2 from "./kfhd2";
import bankRoutes from "./bank";
import mentoringRoutes from "./mentoring";
import onlineRoutes from "./online";
import midAutumnRoutes from "./midAutumn";
import newAreaAppoint from "./newArea-appoint";
import prebook from "./prebook";
import refluxCustomer from "./refluxCustomer";
import anniversary from "./anniversary";
import crossYear from './crossYear';
import aniEvent from './aniEvent';
import springFestival from './springFestival';

Vue.use(Router);

const router = new Router({
    mode: "history",
    base: "/hjwq",
    routes: [
        ...kfhdRoutes,
        ...kfhdRoutes2,
        ...bankRoutes,
        ...mentoringRoutes,
        ...onlineRoutes,
        ...midAutumnRoutes,
        ...newAreaAppoint,
        ...prebook,
        ...refluxCustomer,
        ...anniversary,
        ...crossYear,
        ...aniEvent,
        ...springFestival
    ],
});

export default router;


// WEBPACK FOOTER //
// ./src/router/hjwq/index.js